// extracted by mini-css-extract-plugin
export default {"button":"Button_button__8vMOn","outlined":"Button_outlined__qlufr","danger":"Button_danger__UYfHM","primary":"Button_primary__62QmY","disabled":"Button_disabled__jhw7V"};